import { render } from "./TardyManagementAppointments.vue?vue&type=template&id=beb0d160"
import script from "./TardyManagementAppointments.vue?vue&type=script&lang=js"
export * from "./TardyManagementAppointments.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__